import { forwardRef } from 'react';
import { IMaskInput } from 'react-imask';

type PhoneFIeldProps = {
    onChange: (event: { target: { name: string; value: string } }) => void;
    name: string;
};

const PhoneField = forwardRef<HTMLInputElement, PhoneFIeldProps>(function PhoneMaskInput(props, ref) {
    const { onChange, name, ...otherProps } = props;

    return (
        <IMaskInput
            {...otherProps}
            mask="+7 (000) 000 00 00"
            inputRef={ref}
            onAccept={(value: any) => onChange({ target: { name, value } })}
            overwrite
        />
    );
});

export default PhoneField;
